import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Route, CheckCircle2, Ban } from "lucide-react";

// Iter 98: bloco "Entregas por Rota" — um card por rota (só rotas com entregas no
// período/filtros do dashboard). Sem valores monetários por decisão do usuário.
function RotaStatCard({ r }) {
  const cor = r.cor || "#64748B";
  return (
    <div data-testid={`dash-rota-${r.rota_id}`} data-rota-nome={r.nome}
      className="relative rounded-xl border bg-white p-4 overflow-hidden transition-shadow hover:shadow-md"
      style={{ borderColor: `${cor}66`, boxShadow: `inset 4px 0 0 ${cor}` }}>
      <div className="flex items-center gap-2 min-w-0">
        <span className="w-3 h-3 rounded-full shrink-0" style={{ backgroundColor: cor }} />
        <span className="font-semibold text-sm truncate" title={r.nome}>{r.nome}</span>
        {r.ativa === false && <span className="text-[10px] uppercase text-slate-500 bg-slate-100 rounded px-1">inativa</span>}
      </div>
      <div className="mt-2 flex items-end justify-between gap-2">
        <div>
          <div className="text-3xl font-extrabold leading-none" style={{ color: cor }} data-testid={`dash-rota-total-${r.rota_id}`}>{r.total}</div>
          <div className="text-[11px] text-muted-foreground mt-1">entregas</div>
        </div>
        <div className="text-right text-xs space-y-1">
          <div className="inline-flex items-center gap-1 text-emerald-700" data-testid={`dash-rota-concluidas-${r.rota_id}`}>
            <CheckCircle2 className="w-3.5 h-3.5" /><b>{r.concluidas}</b> concluídas
          </div>
          <br />
          <div className="inline-flex items-center gap-1 text-rose-700" data-testid={`dash-rota-canceladas-${r.rota_id}`}>
            <Ban className="w-3.5 h-3.5" /><b>{r.canceladas}</b> canceladas
          </div>
        </div>
      </div>
    </div>
  );
}

export function RotasResumo({ rotas }) {
  if (!Array.isArray(rotas) || rotas.length === 0) return null;
  return (
    <Card data-testid="dash-rotas-card" className="border-orange-100">
      <CardHeader className="flex flex-row items-center justify-between pb-3">
        <CardTitle className="flex items-center gap-2 text-base"><Route className="w-5 h-5 text-orange-600" />Entregas por Rota</CardTitle>
        <span className="text-xs text-muted-foreground" data-testid="dash-rotas-count">{rotas.length} rota{rotas.length === 1 ? "" : "s"} com entregas no período</span>
      </CardHeader>
      <CardContent className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {rotas.map((r) => <RotaStatCard key={r.rota_id} r={r} />)}
      </CardContent>
    </Card>
  );
}
